module.exports = __webpack_public_path__ + "img/index_tip_bankuai_mobile.8fc8dd20.png";